module.exports = __webpack_public_path__ + "img/karl_hauptmann.79e66bda.jpeg";